export default __webpack_public_path__ + "images/0xd8321aa83fb0a4ecd6348d4577431310a6e0814d.png";